<template functional>
    <a ref="props.link" :href="props.href" v-track:click="{ category: 'Outbound', label: props.href }">
        <slot></slot>
    </a>
</template>
<script>
export default {
    props: ['href'],
}
</script>
